<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button
          @click="openAdd"
          color="primary"
          type="filled"
        >
          Add New
        </vs-button>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <ul class="demo-alignment pb-0" style="float: right">
          <li>
            <div v-if="searchable" style="float:right;">
              <vs-input id="search" class="inputx" placeholder="Search..." v-model="search" v-on:input="debounceInput" />
            </div>
          </li>
          <li>
            <div class="text-center pt-2"><i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary" @click="onExport()"></i> </div>
          </li>
        </ul>

      </vs-col>
    </vs-row>
    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px;"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3 ">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(promo_status)="data">
          <span v-if="data.item.promo_status == 1" class="text-success"
            >Active</span
          >
          <span v-if="data.item.promo_status == 0" class="text-danger"
            >Inactive</span
          >
        </template>

        <template v-slot:cell(promotitle)="data">
          <div v-html="data.item.promotitle"></div>
          <div style="font-size: 11px; color: rgba(0,0,0,.45);" v-html="data.item.promodesc"></div>
          <div style="font-size: 10px; color: rgba(0,0,0,.45);">{{ data.item.register_link }}</div>

        </template>

        <template v-slot:cell(disclevel)="data">
          {{ data.item.disclevel[0].toUpperCase() + data.item.disclevel.slice(1) }}
        </template>

        <template v-slot:cell(disctype)="data">
          <strong v-if="data.item.disctype == 'percent'">{{ data.item.discvalue | numFormat("0,0.0").replace('.0','') }}%</strong>
          <strong v-if="data.item.disctype == 'amount'">{{ data.item.discvalue | numFormat("0,0.00").replace('.00','') }} {{currency}}</strong>
        </template>
        <template v-slot:cell(usage)="data">
          <div style="min-width:300px">
            <div style="display:flex;justify-content:space-between;">
              <div>
                <div>{{ data.item.used || 0 }} used</div>
              </div>
              <div>
                <div v-if="data.item.qty">{{ data.item.qty }}</div>
                <div v-else>Unlimited</div>
              </div>
            </div>

            <div>
              <vs-progress :percent="(data.item.used || 0) * 100 / (data.item.qty || 1)" color="primary"></vs-progress>
            </div>
            <div v-if="data.item.qty" style="font-size: 0.75rem; color: #626262">
              {{ data.item.qty ? (data.item.qty - (data.item.used || 0)) : 'N/A' }} remaining
            </div>

          </div>
        </template>

        <template v-slot:cell(action)="data">
          <div class="d-flex">
            <vs-button @click="open(data.item)" color="primary" type="flat"
              >Edit</vs-button
            >
            <vs-dropdown :vs-trigger-click="true">
              <a class="a-icon" href="#">
                <vs-button color="primary" type="flat" class="ml-3"
                  ><i class="fas fa-ellipsis-v text-grey" style="font-size: 1.5rem"></i>
                </vs-button>
              </a>

              <vs-dropdown-menu :vs-trigger-click="true">
                <vs-dropdown-item class="ellipsis-text">
                  <div
                    class="d-flex align-items-center p-3"
                    @click="openDeleteDialog(data.item)"
                  >
                    <i class="far fa-trash-alt menu-icon mr-2"></i>
                    <span>Delete</span>
                  </div>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </template>
      </b-table>
      <div class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          :max="7"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>
      </div>
    </vx-card>
    <vs-popup
      classContent="popup-confirm"
      title="Confirm Delete"
      :active.sync="deleteDialog"
    >
      <div>Are you sure you want to delete the promotion?</div>
      <div class="wrap-button text-right">
        <vs-button
          color="dark"
          type="border"
          class="mr-2"
          style="font-size: 12px !important;"
          @click="deleteDialog = false"
        >
          No
        </vs-button>
        <vs-button
          color="primary"
          style="font-size: 12px !important;"
          @click="onDeletePromo()"
        >
          Yes
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Service from "@/services";

import { mapState } from "vuex";

import XLSX from "xlsx"; // import xlsx


export default {
  components: {},
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  data: () => ({
    columns: [
      { label: "ID", key: "promo_id", sortable: false },
      { label: "Status", key: "promo_status", sortable: false },
      {
        label: "Campaign",
        key: "promotitle",
        sortable: false,
        tdClass: "width-450"
      },
      // {
      //   label: "Description",
      //   key: "promodesc",
      //   sortable: false,
      //   tdClass: "width-450"
      // },
      { label: "Discount", key: "disctype", sortable: false },
      { label: "Level", key: "disclevel", sortable: false },
      { label: "Discount from", key: "discfrom_display", sortable: false },
      { label: "Start", key: "date_start", sortable: false },
      { label: "End", key: "date_end", sortable: false },
      { label: "Applies to", key: "applyto", sortable: false },
      {
        label: "Usage", key: "usage", sortable: false,
        tdClass: "width-450"
      },
      // { label: "Apply to", key: "applyto", sortable: false },
      { label: "Note", key: "promonote", sortable: false },
      { label: "", key: "action", sortable: false },
    ],
    searchable: true,
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    paramsData: "",
    domainName: '',
    folder: '',
    currency: '',
    deleteDialog: false,
    selectedPromoToDelete: null
  }),
  watch: {
		'currentPage'(val, oldVal) {
			if (oldVal != val) {
				this.getDataPage(val)
			}
		}
	},
  mounted() {
    window.addEventListener("keydown", e => {
      if (this.remarkDialog == false) {
        if (!event.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },
  created() { this.loadEvent() },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function(val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    loadEvent() {
      Service.Event.get(this.e)
        .then(res => {
          if (res.data.event && res.data.event.currency) {
            this.currency = res.data.event.currency;
          }
        })
        .catch(e => {
          console.log(e, 'error')
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });

    },
    onExport() {
      let rows = [];
      let days = [];
      let header = [];

      header = ["ID", "Status", "Code", "Promo", "Description", "Discount", "Level", "Discount from", "Start", "End", "Applies to", "Qty", "Used", "Remaining", "Note"].map((item) => {
        return { text: item };
      });

      this.$vs.loading();
      try {
        this.dataProvider({}, (rows) => {
          const rowsData = rows.map((item) => {
            let discount =''
            if(item.disctype == 'percent') {
              discount = `${item.discvalue}%`
            } else if(item.disctype == 'amount') {
              discount = `${item.discvalue } ${this.currency}`
            }
            return {
              "ID": item.promo_id,
              "Status": item.promo_status == 1 ? 'Active' : 'Inactive',
              "Promo": item.promotitle,
              "Description": item.promodesc,
              "Link": item.register_link || '',
              "Discount": discount,
              "Level": item.disclevel[0].toUpperCase() + item.disclevel.slice(1),
              "Discount from": item.discfrom_display,
              "Start": item.date_start,
              "End": item.date_end,
              "Applies to": item.applyto,
              "Quota": (!item.qty && item.qty !== 0) ? 'Unlimited' : item.qty,
              "Used": item.used || 0,
              "Remaining": item.qty ? (item.qty - item.used) : '',
              "Note": item.promonote
            }
          })
          console.log('rowsData', rowsData)
          const dataWS = XLSX.utils.json_to_sheet(rowsData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, "promotion_report.xlsx");
          this.$vs.loading.close();
        }, 9999)
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    dataProvider(ctx, callback, size = 0) {
      setTimeout(() => {
        this.isBusy = true;

        let data = {
          e: this.$route.query.e,
          // promo_type: "link"
          promo_type: this.$route.path === '/promotions' ? 'std': 'link'
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        // params =
        //   params +
        //   "&" +
        //   Object.keys(ctx)
        //     .map(key => key + "=" + ctx[key])
        //     .join("&");

          const path = this.$route.path === '/promotions' ? 'promotions': 'special_links';
          this.paramsData = params + `&type=${path}&page=${this.currentPage}`;
          if (size) {
          this.paramsData = this.paramsData + `&size=${size}`;
        }
        if (this.filter) {
          this.paramsData = this.paramsData + `&filter=${this.filter}`;
        }
        Service.Bootsale.getPromos(this.paramsData)
          .then(res => {
            this.isBusy = false;
            this.domainName = this.$route.query.s
            this.folder = this.$route.query.e
            this.data = res.rows;
            this.totalRows = res.paginate.total_items;
            this.currentPage = res.paginate.current_page;
            this.perPage = res.paginate.per_page;
            // this.totalRows = res.data.total;
            // this.from = res.data.from;
            // this.to = res.data.to;
            // this.data = res.data.rows;
            // this.log = res.log;
            // this.lagacy_query = res.lagacy_query;

            callback(this.data);
          })
          .catch(error => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1000);
    },
    open(item) {
      this.$router.push(
        "/special-links/" + item.promo_id + "/view?e=" + this.e + "&s=" + this.s
      );
    },
    openDeleteDialog(item) {
      let data = {
        e: this.e
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");
      Service.Bootsale.getPromo(item.promo_id, params)
        .then(promo => {
          this.selectedPromoToDelete = promo.data.promo;

          this.deleteDialog = true;
        })
        .catch();
    },
    onDeletePromo() {
      this.$vs.loading();
      Service.Bootsale.updatePromo(this.selectedPromoToDelete.promo_id, {
        e: this.e,
        ...this.selectedPromoToDelete,
        trash_status: 1
      })
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Delete speciallink completed.",
              color: "success"
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        })
        .finally(() => {
          this.deleteDialog = false;
          this.$refs.table.refresh();
        });
    },
    openAdd() {
      const path = this.$route.path;
      if (path === '/promotions') {
        this.$router.push(`/special-links/add-promo?s=${this.s}&e=${this.e}`)
      }
      else {
        this.$router.push(`/special-links/add?s=${this.s}&e=${this.e}`)
      }
    },
    getDataPage(page) {
          const path = this.$route.path === '/promotions' ? 'promotions': 'special_links';
          let data = {
          e: this.$route.query.e,
          promo_type: this.$route.path === '/promotions' ? 'std': 'link',
          filter: this.filter
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

          this.paramsData = params + `&filter=${this.filter}&type=${path}&page=${page}`
        Service.Bootsale.getPromos(this.paramsData)
          .then(res => {
            this.isBusy = false;
            // console.log(res, 'data')
            this.data = res.rows;
            this.totalRows = res.paginate.total_items;
            this.currentPage = res.paginate.current_page;
            this.perPage = res.paginate.per_page;

          })
          .catch(() => {
            // console.log(error);
          });
    }
  }
};
</script>
